import type { BaseKeyFunction } from "../../../../lib/types/baseKeyFunction";

export const keySessionsCount: BaseKeyFunction = () => ["sessions", "count"];
